import React, { useEffect, useState } from 'react';
import client from 'utils/client';
import dayjs from 'dayjs';
import AppDataGrid from 'components/AppDataGrid/AppDataGrid';
import { Link } from 'react-router-dom';
import ModalComponent from 'components/Modal/Modal';
import { useModal } from 'components/Modal/useModal';
import { useToast } from 'components/Toast/useToast';
import { useAuth } from 'contexts/AuthContext';
import './staff.css';
import EditStaff from './edit/EditStaff';
import { ActivePill } from 'components/StatusPill/StatusPill';

function toggleStaff(id, payload) {
  return client.put(`/staff/${id}/update`, payload);
}

function Staff() {
  const { isAdmin } = useAuth();

  React.useEffect(() => {
    if (!isAdmin) window.location = '/';
  }, [isAdmin]);

  const [loading, setLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [staff, setStaff] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);

  const { isOpen, onOpen } = useModal();
  const { onOpen: OpenToast } = useToast();
  const [selectedStaff, setSelectedStaff] = useState(null);

  useEffect(() => {
    setLoading(true);
    client
      .get(`/staff`)
      .then((response) => {
        setStaff(() => response.data.data);
      })
      .catch((error) => setError(error))
      .finally(() => setLoading(false));
  }, []);

  function handleToggleStaff(id, active) {
    setIsUpdating(true);
    return toggleStaff(id, { active: !active })
      .then(() => {
        OpenToast({ message: 'Updated Successfully' });
        window.location.reload();
      })
      .catch((err) => {
        OpenToast({ type: 'error', message: err?.message || 'An Error Occured' });
      })
      .finally(() => setIsUpdating(false));
  }

  const renderDetailsButton = (params) => {
    const { active, id } = params.row;
    return (
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          type='button'
          className='btn-secondary'
          disabled={isUpdating}
          onClick={() => { setSelectedStaff(params.row); onOpen(); }}>
          Edit
        </button>
        <button
          type='button'
          className={active ? 'btn-danger' : 'btn-secondary'}
          disabled={isUpdating}
          onClick={(e) => { e.stopPropagation(); handleToggleStaff(id, active); }}>
          {active ? 'Disable' : 'Enable'}
        </button>
      </div>
    );
  };

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      width: 200,
      sortable: false,
      valueGetter: (p) => `${p.row.first_name || ''} ${p.row.last_name || ''}`.trim(),
    },
    { field: 'email', headerName: 'Email', width: 240 },
    {
      field: 'active',
      headerName: 'Status',
      width: 110,
      renderCell: (p) => <ActivePill active={p.row.active} />,
    },
    {
      field: 'created_at',
      headerName: 'Created',
      width: 180,
      valueGetter: (p) => dayjs(p.row.created_at).format('MMM DD, YYYY h:mma'),
    },
    {
      field: 'actions',
      headerName: '',
      width: 180,
      sortable: false,
      filterable: false,
      align: 'right',
      headerAlign: 'right',
      renderCell: renderDetailsButton,
    },
  ];

  return (
    <>
      {isOpen ? (
        <ModalComponent title='Edit Staff' styles={{ maxWidth: '500px', minHeight: '400px' }} children={<EditStaff data={selectedStaff} />} />
      ) : null}

      <div className='staff'>
        <div className='staff-title-container'>
          <h1 className='staff-title'>Staff</h1>
          <Link to='/new-staff'>
            <button className='staff-add-button'>Create</button>
          </Link>
        </div>
        <AppDataGrid
          className='staff-list'
          rows={staff}
          columns={columns}
          loading={loading}
        />
      </div>
    </>
  );
}

export default Staff;
